import React from "react";
import Link from "next/link";
import { IPagesDropdown } from "@/types/menu-d-t";
import { ifArabic, getLocalizedPath } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

type IProps = {
  pages_dropdown: IPagesDropdown[];
  onHandleOffCanvas?: () => void;
};

export default function NavPagesDropdown({
  pages_dropdown,
  onHandleOffCanvas,
}: IProps) {
  const { language } = useLanguage();

  return (
    <div className="megamenu-demo-fullwidth p-relative">
      <div className="row">
        <div className="col-lg-12">
          <div className="tp-megamenu-fullwidth-list-wrapper">
            <div className="row tp-gx-90">
              {pages_dropdown.map((pd) => (
                <div key={pd.id} className={`col-xl-4`}>
                  <div className="tp-megamenu-fullwidth-list">
                    <div>
                      <h4
                        className={`tp-megamenu-fullwidth-title ${
                          pd?.noBorder ? "no-border" : ""
                        }`}
                      >
                        {pd?.link ? (
                          <Link
                            aria-label={pd.title}
                            href={getLocalizedPath(pd.link || "#", language)}
                            onClick={onHandleOffCanvas}
                          >
                            {ifArabic(pd.titleAr, pd.title)}
                          </Link>
                        ) : (
                          ifArabic(pd.titleAr, pd.title)
                        )}
                      </h4>
                    </div>
                    <ul>
                      {pd.dropdown_menus.map((sm) => (
                        <li key={sm.id}>
                          <Link
                            aria-label={sm.title}
                            href={getLocalizedPath(sm.link || "#", language)}
                            onClick={onHandleOffCanvas}
                          >
                            {ifArabic(sm.titleAr, sm.title)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
